import { render } from "./RoomBookingBanner.vue?vue&type=template&id=d9be52e8"
import script from "./RoomBookingBanner.vue?vue&type=script&lang=js"
export * from "./RoomBookingBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__